import { parseMentionSegments } from '@tempo-io/fim3-dto';

export const MentionText = ({ text }: { text: string }) => (
  <>
    {Object.entries(parseMentionSegments(text)).map(([key, segment]) =>
      segment.type === 'mention' ? (
        <span
          key={key}
          className="rounded bg-fill-brand-secondary px-1 font-medium text-text-brand"
          data-testid="fim3-comment-mention"
        >
          @{segment.name}
        </span>
      ) : (
        <span key={key}>{segment.text}</span>
      ),
    )}
  </>
);
